import { ApolloClient } from '@apollo/client';
import {
  CommonQueryFiltersType,
  MENU_SECTIONS,
  ProductSelection,
  ProductsQueryOptionsArgs,
  ProductType,
} from 'components/ProductsSelection/types';
import { getArrayOfKeys } from 'utils/functions';
import { FilterSelectionType } from 'utils/types';

export const getMenuFilters = (
  menuSections: Array<ProductType>,
  selection: ProductSelection,
  currentProductType: ProductType
) => {
  let menuQueryFilters: FilterSelectionType = {
    accounts: [],
    states: [],
    stores: [],
    items: [],
  };

  menuSections.forEach((section: ProductType) => {
    if (currentProductType !== section) {
      menuQueryFilters = {
        ...menuQueryFilters,
        [section]: getArrayOfKeys(selection[section], 'id'),
      };
    }
  });

  return menuQueryFilters;
};

export const getQueryOptions = (
  options: ProductsQueryOptionsArgs,
  commonQueryFilters: CommonQueryFiltersType,
  selectionApplied: ProductSelection,
  client: ApolloClient<any>,
  skip?: boolean
) => {
  return {
    defaultSortAttribute: options.defaultSortAttribute,
    defaultSearchAttribute: options.defaultSearchAttribute,
    queryVariables: {
      ...commonQueryFilters,
      ...getMenuFilters(MENU_SECTIONS, selectionApplied, options.productType),
      products: options.productType === 'items' ? [] : getArrayOfKeys(selectionApplied.items, 'id'),
    },
    resultAttribute: options.resultAttribute,
    client,
    skip,
  };
};
